import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as favouritesGAEventsMap } from 'src/redux/favourites/tracking/eventsMap';
import { GAEventsMap as productMediaCarouselGAEventsMap } from 'src/redux/productMediaCarousel/tracking/eventsMap';
import { GAEventsMap as basketGAEventsMap } from './basket/eventsMap';
import { GAEventsMap as basketTrackingGAEventsMap } from './basket/tracking/eventsMap';
import type { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as deliveryGAEventsMap } from './delivery/tracking/eventsMap';

const eventsMap = {
  ...basketGAEventsMap,
  ...basketTrackingGAEventsMap,
  ...deliveryGAEventsMap,
  ...favouritesGAEventsMap,
  ...productMediaCarouselGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
